export default __webpack_public_path__ + "static/media/icon-check.daa8ab8e.svg";